<template>
  <div class="brand-container">
    <h1 class="align-center fs50 my40 cl-dark-blue weight-500">
      {{ name }}
    </h1>
    <div class="col-sm-12 col-xs-12 masonry">
      <div
        v-for="(letter, index) in alphabetArray"
        :key="index"
        class="mt10"
        v-if="letterCategory(letter).length > 0"
      >
        <div class="row">
          <h2 class="col-xs-12 mb10 uppercase weight-500 fs-big mt0 cl-dark-blue">
            {{ letter }}
          </h2>
          <div v-for="category in letterCategory(letter)" :key="category.id" class="col-xs-12 mb10">
            <router-link
              class="no-underline cl-dark-blue"
              :to="localizedRoute('/' + category.url_path)"
            >
              {{ category.name }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      alphabet: '0123456789abcdefghijklmnopqrstuvwxyz'
    }
  },
  props: {
    categories: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  methods: {
    scrollMeTo (refName) {
      let element = this.$refs[refName]
      let top = element[0].offsetTop
      let topWithoutOffset = top - 100
      window.scrollTo({ top: topWithoutOffset, left: 0, behavior: 'smooth' })
    },
    letterCategory (letter) {
      return this.categories.filter(c => { return c.name.charAt(0).toLowerCase() === letter })
    }
  },
  computed: {
    alphabetArray () {
      var alphabetArray = []
      alphabetArray = this.alphabet.split('')
      return alphabetArray
    }
  }
}
</script>

<style lang="scss" scoped>
.pr-letters {
  display: flex;
  flex-wrap: wrap;
}
.letter-box {
  .letter-p {
    display: inline;
    padding: 5px;
    margin: 0;
  }
  &:before {
    background-color: #fff;
    content: "";
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: 5%;
    border-bottom: 1px solid;
  }
  &:after {
    background-color: #fff;
    content: "";
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: 90%;
    border-bottom: 1px solid;
    @media (max-width: 767px) {
      width: 80%;
    }
  }
}
.masonry {
  .row {
    @media (max-width: 767px) {
      text-align: center;
      margin-bottom: 30px;
    }
  }
  max-width: 800px;
  columns: 3 200px;
  column-gap: 1rem;
}
.brand-container {
  h1 {
    @media (max-width: 767px) {
      margin-top: 20px;
      margin-bottom: 20px;
      font-size: 30px;
    }
  }
  margin: 0 auto;
}
</style>
